/**
 * English plural for a single operator-configured term (e.g. `action_name`).
 * Used when only the singular label is stored in operator settings.
 */
function pluralizeOperatorTerminology(singular: string): string {
  const s = singular.trim();
  if (!s) return singular;

  let plural: string;
  if (/(?:s|x|z|ch|sh)$/i.test(s)) {
    plural = `${s}es`;
  } else if (/[^aeiou]y$/i.test(s) && s.length > 1) {
    plural = `${s.slice(0, -1)}ies`;
  } else {
    plural = `${s}s`;
  }

  if (s === s.toUpperCase() && /[a-z]/i.test(s)) {
    return plural.toUpperCase();
  }
  return plural;
}

export default pluralizeOperatorTerminology;
